import * as React from 'react';

import { useAuth } from '../../contexts/auth/useAuth';
import { ViewProfile } from './ViewProfile';
import { IProfile } from '../../api/models/IProfile';
import { ProfileApi } from '../../api/services/ProfileApi';
import { AccountContext, TAccountManagerMode } from './IAccountContext';
import { EditProfile } from './EditProfile';
import { AccountPane } from './AccountPane';

const AccountManager = () => {
  const auth = useAuth();
  const [mode, setMode] = React.useState<TAccountManagerMode>('view');

  const updateProfile = async (profile: IProfile) => {
    if (!auth.user) return false;
    try {
      // Pre-strict-mode this used `auth.user.id`, which doesn't exist on
      // IUser — the id field is named `uuid`.
      await ProfileApi.update(profile, auth.user.email, auth.user.uuid)
      auth.setUser({ ...auth.user, name: profile.name, country: profile.country });
      return true;
    } catch {
      return false;
    }
  }

  const renderPane = () => {
    switch(mode) {
      case 'view': return <ViewProfile/>;
      case 'edit': return <EditProfile/>;
      case 'password': return <AccountPane/>;
      default:
        return null;
    }
  }

  return (
    <AccountContext.Provider value={{
      mode, setMode,
      updateProfile
    }}>
      {renderPane()}
    </AccountContext.Provider>
  )
}

export { AccountManager }
